import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './QRCode.css';

const QRCode = () => {
  const { t } = useTranslation();
  const siteUrl = 'https://eevn.band';

  return (
    <div className="App">
      <Header />
      <div className="qr-code-page">
        <div className="qr-code-container">
          <h1 className="qr-code-title">{t('qrCode.title', 'QR Code')}</h1>
          <p className="qr-code-description">
            {t('qrCode.description', 'Scan this QR code to visit eevn.band')}
          </p>
          <div className="qr-code-wrapper">
            <QRCodeSVG
              value={siteUrl}
              size={300}
              level="H"
              includeMargin={true}
              fgColor="#9D4EDD"
              bgColor="transparent"
            />
          </div>
          <p className="qr-code-url">{siteUrl}</p>
          <a href="/" className="btn-back">
            {t('qrCode.backToHome', 'Back to Home')}
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default QRCode;

